<div [style]="css | safeStyle">
  <div *ngIf="desktopLinkUrl">
    <a *ngIf="internalLink" (click)="navigateToBrowseDevices()">
      <img alt="{{desktopAltText}}" [src]="desktopImageUrl" width="100%" />
    </a>
    <a *ngIf="!internalLink" [href]="desktopLinkUrl">
      <img alt="{{desktopAltText}}" [src]="desktopImageUrl" width="100%" />
    </a>
  </div>
  <img *ngIf="!desktopLinkUrl" alt="{{desktopAltText}}" [src]="desktopImageUrl" width="100%" />
</div>
